"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdatedContactsQuantityConfig = exports.getAdditionalContactQuantityFromConfigurations = exports.createItemConfigObject = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var createItemConfigObject = function createItemConfigObject(_ref) {
  var merchandiseId = _ref.merchandiseId,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity;
  return {
    merchandiseId: merchandiseId,
    quantity: quantity
  };
}; // Returns the additional contacts quantity from a list of merch configurations


exports.createItemConfigObject = createItemConfigObject;

var getAdditionalContactQuantityFromConfigurations = function getAdditionalContactQuantityFromConfigurations(itemConfigurations, contactsMerchandiseId) {
  var contactsConfiguration = itemConfigurations.find(function (configuration) {
    return configuration.merchandiseId === contactsMerchandiseId;
  });
  if (!contactsConfiguration) return 0;
  return contactsConfiguration.quantity;
}; // The purpose of this helper is to override the additional contacts quantity for
// sending to checkout (ex. if the user slides the slider to have more contacts,
// we would want to update the item configurations we will send to offer-builder)


exports.getAdditionalContactQuantityFromConfigurations = getAdditionalContactQuantityFromConfigurations;

var getUpdatedContactsQuantityConfig = function getUpdatedContactsQuantityConfig(args) {
  var itemConfigurations = args.itemConfigurations,
      additionalUnitMerchId = args.additionalUnitMerchId,
      additionalUnitQuantity = args.additionalUnitQuantity;
  var clone = itemConfigurations.map(function (configuration) {
    return Object.assign({}, configuration);
  });
  var existingContactConfigIndex = clone.findIndex(function (configuration) {
    return configuration.merchandiseId === additionalUnitMerchId;
  });

  if (existingContactConfigIndex > -1) {
    if (additionalUnitQuantity <= 0) {
      clone.splice(existingContactConfigIndex, 1);
    } else {
      clone[existingContactConfigIndex].quantity = additionalUnitQuantity;
    }

    return clone;
  }

  if (additionalUnitQuantity <= 0) {
    return clone;
  }

  return [].concat((0, _toConsumableArray2.default)(clone), [createItemConfigObject({
    merchandiseId: additionalUnitMerchId,
    quantity: additionalUnitQuantity
  })]);
};

exports.getUpdatedContactsQuantityConfig = getUpdatedContactsQuantityConfig;